export default __webpack_public_path__ + "static/stocksnap-people-2569234_1920-e0402401f189860547899e1bc85b016b.jpg";